<section class="posts__main">
    <img src={{imgDetail}} alt="">
    <div class="postBody">
        <span>{{dateDetail}}</span>
        <h2>{{titleDetail}}</h2>
        <p>{{contentDetail}}</p>
    </div>
</section>